import { render, staticRenderFns } from "./IntegrationsBase.vue?vue&type=template&id=6efd8250&"
import script from "./IntegrationsBase.vue?vue&type=script&lang=js&"
export * from "./IntegrationsBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports